import { render, staticRenderFns } from "./multipleChoice1.vue?vue&type=template&id=08058930&scoped=true"
import script from "./multipleChoice1.vue?vue&type=script&lang=js"
export * from "./multipleChoice1.vue?vue&type=script&lang=js"
import style0 from "./multipleChoice1.vue?vue&type=style&index=0&id=08058930&prod&lang=css"
import style1 from "./multipleChoice1.vue?vue&type=style&index=1&id=08058930&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08058930",
  null
  
)

export default component.exports